import Layout from '@/components/Layout'
import Seo from '@/components/Seo'
import { company } from '@/lib/site-data'

function TermosUso() {
  return (
    <Layout>
      <Seo
        title="Termos de Uso | Muita Mídia"
        description="Termos de Uso da Muita Mídia LTDA para a venda de páginas nichadas do Instagram, condições de pagamento e responsabilidades das partes."
        path="/termos-de-uso"
      />

      <section className="bg-white">
        <div className="mx-auto max-w-3xl px-6 py-16 sm:py-20">
          <h1 className="text-3xl font-bold text-zinc-900">Termos de Uso</h1>
          <p className="mt-3 text-sm text-zinc-500">Última atualização: janeiro de 2024</p>

          <div className="mt-8 space-y-8 text-base leading-relaxed text-zinc-700">
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">1. Objeto</h2>
              <p className="mt-2">
                Estes Termos de Uso regulam a utilização deste site e a relação comercial entre {company.legalName},
                CNPJ {company.cnpj}, e os clientes interessados na compra de páginas nichadas do Instagram, com faixas de
                {' '}{company.minFollowers} a {company.maxFollowers} seguidores.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">2. Natureza do site</h2>
              <p className="mt-2">
                Este site é institucional e informativo. Não há catálogo de produtos, carrinho de compras ou checkout
                online. Todo o processo de negociação, escolha do nicho e faixa de seguidores, pagamento e entrega é
                conduzido diretamente pelo WhatsApp, com atendimento humano.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">3. Formas de pagamento</h2>
              <p className="mt-2">
                Aceitamos pagamento via Pix, com desconto especial e confirmação instantânea, ou cartão de crédito
                parcelado em até 12 vezes, sendo os juros do link de pagamento de responsabilidade do cliente.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">4. Propriedade das páginas vendidas</h2>
              <p className="mt-2">
                A Muita Mídia é proprietária de todas as páginas comercializadas em seu portfólio. A venda é formalizada
                somente após a confirmação do pagamento, seguida de entrega imediata das credenciais de acesso pelo
                WhatsApp e transferência assistida de propriedade.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">5. Verificação e qualidade das páginas</h2>
              <p className="mt-2">
                Cada página comercializada passa por verificação manual quanto à conformidade com as políticas da Meta
                e do Instagram, histórico de conteúdo e ausência de shadowban ou restrições registradas antes de
                integrar nosso portfólio de vendas.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">6. Garantia</h2>
              <p className="mt-2">
                Todas as vendas contam com garantia de 7 dias, conforme o Código de Defesa do Consumidor, detalhada em
                nossa Política de Garantia. Alterações no perfil (usuário, nome, foto ou biografia) após a entrega
                invalidam o direito de reembolso pela garantia.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">7. Responsabilidades do cliente</h2>
              <p className="mt-2">
                Após a transferência assistida, o cliente é responsável por manter o perfil em conformidade com as
                políticas do Instagram e por utilizar as credenciais recebidas com segurança.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">8. Alterações destes termos</h2>
              <p className="mt-2">
                Podemos atualizar estes Termos de Uso periodicamente. Recomendamos a consulta regular desta página para
                acompanhar eventuais alterações.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default TermosUso
